<ng-container *ngIf="filter">
  <div class="flex-grow relative min-w-[210px]">
    <div class="inset-0 overflow-y-auto overflow-x-hidden max-h-full custom-scroll">
      <elio-filter-item *ngFor="let subFilter of filter.subFilters; trackBy: trackById" [filter]="subFilter" />
    </div>
  </div>
</ng-container>
